import { component, Device, MultiProfileDevice } from './base';
import { BluetoothLowEnergy, Cloud, Cover, Input, Mqtt, OutboundWebSocket, Script, Switch, WiFi } from '../components';

export class ShellyPlus2Pm extends MultiProfileDevice {
    static readonly model: string = 'SNSW-002P16EU';
    static readonly modelName: string = 'Shelly Plus 2 PM';

    @component
    readonly wifi = new WiFi(this);

    @component
    readonly bluetoothLowEnergy = new BluetoothLowEnergy(this);

    @component
    readonly cloud = new Cloud(this);

    @component
    readonly mqtt = new Mqtt(this);

    @component
    readonly outboundWebSocket = new OutboundWebSocket(this);

    @component
    readonly cover0 = new Cover(this, 0);

    @component
    readonly input0 = new Input(this, 0);

    @component
    readonly input1 = new Input(this, 1);

    @component
    readonly switch0 = new Switch(this, 0);

    @component
    readonly switch1 = new Switch(this, 1);

    @component
    readonly script = new Script(this);
}

Device.registerClass(ShellyPlus2Pm);

export class ShellyPlus2PmRev1 extends ShellyPlus2Pm {
    static readonly model: string = 'SNSW-102P16EU';
}

Device.registerClass(ShellyPlus2PmRev1);
